import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  comment: Boundaries["removeComment"]["request"],
) {
  const index = state.findIndex((req) => req.comment.uuid === comment.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { comment, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { comment, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  comment: Boundaries["removeComment"]["success"],
) {
  const index = state.findIndex((req) => req.comment.uuid === comment.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { comment, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { comment, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  comment: Boundaries["removeComment"]["failure"],
) {
  const index = state.findIndex((req) => req.comment.uuid === comment.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { comment, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { comment, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeCommentRequested]: handleRequest,
    [events.removeCommentSucceeded]: handleSuccess,
    [events.removeCommentFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
